export {};
const storageKey = "interactive-studio:competenceo:v1";

function installDopplerExampleButton() {
  if (location.pathname !== "/activity-studio") return;
  if (document.querySelector("[data-doppler-example]")) return;

  const row = document.querySelector<HTMLElement>(".studio-title-row");
  if (!row) return;
  const existing = [...row.querySelectorAll<HTMLButtonElement>("button")].find((button) =>
    button.textContent?.includes("Exemple : diffraction"),
  );
  if (!existing) return;

  const button = document.createElement("button");
  button.type = "button";
  button.dataset.dopplerExample = "true";
  button.className = existing.className;
  button.textContent = "Exemple : Doppler";
  button.title = "Charger l’activité documentaire complète sur l’effet Doppler";
  button.addEventListener("click", async () => {
    // Load the corrected example only on explicit teacher use, never in the public entry bundle.
    button.disabled = true;
    try {
    const {default: doppler} = await import("../docs/examples/doppler-interactive-v1.json");
    const source = JSON.stringify(doppler, null, 2);
    localStorage.setItem(
      storageKey,
      JSON.stringify({ source, lastValid: doppler }),
    );
    location.reload();
    } catch {button.textContent = "Exemple Doppler indisponible — reconnectez-vous comme professeur";button.disabled = false;}
  });

  existing.insertAdjacentElement("afterend", button);
}

const observer = new MutationObserver(installDopplerExampleButton);
observer.observe(document.documentElement, { childList: true, subtree: true });
window.setTimeout(installDopplerExampleButton, 0);
